import { render, staticRenderFns } from "./aShopDetailVip.vue?vue&type=template&id=6c7c97c8&scoped=true"
import script from "./aShopDetailVip.vue?vue&type=script&lang=js"
export * from "./aShopDetailVip.vue?vue&type=script&lang=js"
import style0 from "./aShopDetailVip.vue?vue&type=style&index=0&id=6c7c97c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c7c97c8",
  null
  
)

export default component.exports